import { useState, useEffect } from 'react';
import axios from 'axios';
import {
  packages as defaultPackages,
  drinkItems as defaultDrinkItems,
  STRUCTURE_FEE_PER_PERSON,
  ALMOCO_JANTAR,
} from '../data/mockData';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

/**
 * Hook que devolve os arrays/valores de preços JÁ MESCLADOS com os
 * overrides salvos pelo dono do buffet em /admin/precos.
 *
 *   const { packages, drinkItems, structureFee, almocoJantar, ready } = usePricing();
 *
 * Enquanto faz fetch (poucos ms), devolve os defaults — assim o site nunca quebra.
 */
export const usePricing = () => {
  const [overrides, setOverrides] = useState(null);
  const [ready, setReady] = useState(false);

  useEffect(() => {
    axios.get(`${API}/pricing`)
      .then((res) => {
        setOverrides(res.data || {});
        setReady(true);
      })
      .catch(() => {
        setOverrides({});
        setReady(true);
      });
  }, []);

  const packagesOverrides = (overrides && overrides.packages) || {};
  const drinksOverrides = (overrides && overrides.drinks) || {};

  const packages = defaultPackages.map((p) => {
    const o = packagesOverrides[p.id];
    if (o && typeof o.pricePerPerson === 'number') {
      return { ...p, pricePerPerson: o.pricePerPerson };
    }
    return p;
  });

  const drinkItems = defaultDrinkItems.map((d) => {
    const o = drinksOverrides[d.id];
    if (o && typeof o.pricePerPerson === 'number') {
      return { ...d, pricePerPerson: o.pricePerPerson };
    }
    return d;
  });

  const structureFee = (overrides && typeof overrides.structureFee === 'number')
    ? overrides.structureFee
    : STRUCTURE_FEE_PER_PERSON;

  const almocoJantar = (overrides && typeof overrides.almocoJantar === 'number')
    ? { ...ALMOCO_JANTAR, pricePerPerson: overrides.almocoJantar }
    : ALMOCO_JANTAR;

  const getPackageById = (id) => packages.find((p) => p.id === id);
  const getPackagesForEvent = (eventTypeId) => {
    // duplicate logic from mockData but using the merged list
    const evt = require('../data/mockData').eventTypes.find((e) => e.id === eventTypeId);
    if (!evt) return [];
    return packages.filter((p) => p.group === evt.packageGroup);
  };

  return {
    packages,
    drinkItems,
    structureFee,
    almocoJantar,
    getPackageById,
    getPackagesForEvent,
    ready,
  };
};
